import { Box } from "@mui/material";

import { useOrderContext } from "contexts/OrderContext";
import { businessTypes, RegistrationStatusEnum } from "enums/shared";
import formatHours from "utils/formatHours";
import ContentCard from "Components/shared/ContentCard";
import { useRTL } from "hooks/isRTL";
import LoadingBanner from "Components/shared/LoadingBanner";
import { fallbackValue } from "constants/fallbackConstant";

/**
 * Displays detailed information about the business associated with the order.
 */
const BusinessDetailsTab = () => {
  const { senderDetails, isLoading, isError } = useOrderContext();

  const { t } = useRTL();
  if (isLoading) return <LoadingBanner />;
  if (isError) return <p>Error loading business details.</p>;

  const getStatusLabel = (status) => {
    const entry = Object.entries(RegistrationStatusEnum).find(
      ([, value]) => value === status
    );
    return entry ? t(entry[0]) : fallbackValue;
  };
  /**
   * Content array for the business details, rendered in the `ContentCard`.
   * @type {Array<{label: string, value: string}>}
   */
  const content = [
    { label: t("fullName"), value: senderDetails?.fullName || fallbackValue },
    {
      label: t("phoneNumber"),
      value: senderDetails?.phoneNumber.replace("_", "") || fallbackValue,
    },
    {
      label: t("businessType"),
      value: t(businessTypes[senderDetails?.busnissType]) || "Unknown",
    },
    { label: t("email"), value: senderDetails?.email || fallbackValue },
    {
      label: t("nationalNumber"),
      value: senderDetails?.nationalNumber || fallbackValue,
    },
    { label: t("website"), value: senderDetails?.website || fallbackValue },
    { label: t("address"), value: senderDetails?.address || fallbackValue },
    {
      label: t("openHours"),
      value: formatHours(senderDetails?.openHours) || fallbackValue,
    },
    {
      label: t("status"),
      value: getStatusLabel(senderDetails?.status),
    },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "1rem",
        padding: "1rem",
      }}
    >
      <ContentCard title={t("businessDetails")} content={content} />

      <Box
        sx={{
          visibility: "hidden",
        }}
      >
        <ContentCard title="" content={[]} />
      </Box>
    </Box>
  );
};

export default BusinessDetailsTab;
